import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Input, Modal, ModalBody, ModalFooter, ModalHeader, Table } from "reactstrap";
import * as Yup from "yup";
import { RootState } from "../../../redux/Reducer";
import SaleRepClassificationCard from "../../../components/SalesRepClassificationCard/salesRepClassifictationCard";
import RationalistImg from "../../../assets/Images/RationalistImg.png"
import PerformerImg from "../../../assets/Images/PerformerImg.png";
import HarmonizerImg from "../../../assets/Images/HarmonizerImg.png";
import OptimizerImg from "../../../assets/Images/OptimizerImg.png";
import { cardContentArr } from "../../../utils/content";
import NewCard from "./NewCard";
import { SAVE_DOCUMENT_OUTCOME } from "../../../redux/Action/actionTypes";
import { useNavigate } from "react-router-dom";
import ToastNotifier from "../../../components/ToastNotifier/toastNotifier";
import { getSalesRepClassificationList } from "../../../redux/Action/Action";

interface InitialValues {
    Rating: number;
    improvements: string;
    supplier: string;
    leadSalesRep: string;
    nextNegotiation: string;
    confirmSalesRepType?: boolean;
}
const ReviewNegotiation = () => {
    const navigate = useNavigate();
    let maxRating = 5;
    const initialValues: InitialValues = {
        Rating: 0,
        improvements: '',
        supplier: '',
        leadSalesRep: '',
        nextNegotiation: '',
        confirmSalesRepType: true
    }
    const validationSchema = Yup.object({
        Rating: Yup.number().required(),
        improvements: Yup.string().max(5000, "Maximum 5000 characters allowed").required("This is a required field"),
        supplier: Yup.string().max(5000, "Maximum 5000 characters allowed").required("This is a required field"),
        leadSalesRep: Yup.string().max(5000, "Maximum 5000 characters allowed").required("This is a required field"),
        nextNegotiation: Yup.string().max(5000, "Maximum 5000 characters allowed")
    })
    const formik = useFormik({
        initialValues,
        validationSchema,
        validateOnMount: true,
        validateOnBlur: true,
        validateOnChange: false,

        onSubmit: (values) => { },
    });
    const [isNextDisabled, setIsNextDisabled] = useState<boolean>(true);
    const [isSalesRepNull, setIsSalesRepNull] = useState<boolean>(true);
    useEffect(() => {
        setIsNextDisabled(!(formik.isValid && formik.dirty));
    }, [formik.isValid, formik.dirty]);
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getSalesRepClassificationList())
    }, []);
    const salesRepClassficationList = useSelector(
        (state: RootState) => state.DocumentOutcome?.salesRepClassificationList
    );
    const SalesRepDatainPrev = useSelector(
        (state: RootState) => state.dashboardData.detailedOverviewData.salesRepClassification
    );
    const SalesRepDatainClose = useSelector(
        (state: RootState) => state.dashboardData.closeNegotiaitionData.salesRepClassification
    );
    const DocOutcomeData = useSelector((state: RootState) => state.DocumentOutcome?.DocOutcomeData)
    const TargetValueDataInPrev = useSelector(
        (state: RootState) => state.dashboardData.detailedOverviewData.targetValue
    );
    const TargetValueDataInClose = useSelector(
        (state: RootState) => state.dashboardData.closeNegotiaitionData.targetValue
    );
    const contractStatus = useSelector(
        (state: RootState) => state.dashboardData.contractStatus
    );
    const TargetValueData =
        contractStatus === "inReview"
            ? TargetValueDataInClose
            : TargetValueDataInPrev;

    useEffect(() => {
        if (TargetValueData?.length == 0 || TargetValueData == undefined) {
            navigate('/')
        }
    }, [])
    const SalesRepData = contractStatus === "inReview" ? SalesRepDatainClose : SalesRepDatainPrev

    const detailedGetId = useSelector(
        (state: RootState) => state.dashboardData?.detailedOverviewData?.planNegotiationActions?.
            negotiationId
    );
    const closeNegoGetId = useSelector(
        (state: RootState) => state.dashboardData?.closeNegotiaitionData?.planNegotiationActions?.
            negotiationId
    );
    const GetId =
        contractStatus === "inReview"
            ? closeNegoGetId
            : detailedGetId;
    const negotiationCardsInPrev = useSelector((state: RootState) => state.dashboardData?.detailedOverviewData?.planNegotiationActions?.negotiationRoundsDetails);
    const negotiationCardsInClose = useSelector((state: RootState) => state.dashboardData?.closeNegotiaitionData?.planNegotiationActions?.negotiationRoundsDetails);
    const negotiationCards = contractStatus === "inReview" ? negotiationCardsInClose : negotiationCardsInPrev
    const [salesRepType, setSalesRepType] = useState<{ id: string; title: string }>({ id: SalesRepData?.salesRepClassificationId, title: SalesRepData?.salesRepClassificationTitle });

    const [cardDataByRound, setCardDataByRound] = useState<{
        [roundName: string]: {
            cardId: string;
            ActionEffectivenessReason: string;
            Rating: number;
        }[];
    }>({});
    const [hover, setHover] = useState(0);
    const [saveReview, setSaveReview] = useState(false)


    const handleCardDataChange = (data: {
        roundName: string;
        cardId: string;
        ActionEffectivenessReason: string;
        Rating: number;
    }) => {
        setCardDataByRound(prev => {
            const roundData = prev[data.roundName] || [];
            const existingIndex = roundData.findIndex(
                item => item.cardId === data.cardId
            );
            const updatedCard = {
                cardId: data.cardId,
                ActionEffectivenessReason: data.ActionEffectivenessReason,
                Rating: data.Rating,
            };
            const updatedRoundData =
                existingIndex !== -1
                    ? [...roundData.slice(0, existingIndex), updatedCard, ...roundData.slice(existingIndex + 1)]
                    : [...roundData, updatedCard];
            return {
                ...prev,
                [data.roundName]: updatedRoundData,
            };
        });
    };
    const areAllCardsRated = () => {
        const uniqueCardMap = new Map<string, { cardId: string; roundName: string }>();
        negotiationCards?.forEach((round: any) => {
            const isNegotiationRound = /^Round[1-9]$|^Round10$/.test(round.roundName);
            let roundName:any;
            if (round.roundName === "Preparation" || round.roundName === "Finalization") {
                roundName = round.roundName;
            } else if (isNegotiationRound) {
                roundName = "NegotiationRound";
            } else {
                roundName = null;
            }
            if (!roundName) return;
            round.selectedAction
                ?.filter((action: any) => action.isNegotiationActionUsed)
                .forEach((action: any) => {
                    if (!uniqueCardMap.has(action.id)) {
                        uniqueCardMap.set(action.id, { cardId: action.id, roundName });
                    }
                });
        });
        const uniqueVisibleCards = Array.from(uniqueCardMap.values());
        return uniqueVisibleCards.every(({ cardId, roundName }) =>
            cardDataByRound[roundName]?.some((item) => item.cardId === cardId && item.Rating > 0)
        );
    };

    const handleSubmitClick = () => {
        if (areAllCardsRated()) {
             setSaveReview(true)
        }
    }
    const confirmSubmit = () => {
        const transformedCardData = Object.entries(cardDataByRound).map(([round, cards]) => ({
            [round]: cards
        }));
        const outputData = transformedCardData.map(obj => {
            const roundName = Object.keys(obj)[0];
            const selectedAction = obj[roundName].map(item => ({
                id: item.cardId,
                Rating: item.Rating,
                ActionEffectivenessReason: item.ActionEffectivenessReason
            }));
            return { roundName, selectedAction };
        });

        let finalData = {
            id: GetId,
            TargetOutcome: DocOutcomeData.TargetOutcome,
            DiscountTerms: DocOutcomeData.DiscountTerms,
            PaymentTermsOutcome: DocOutcomeData.PaymentTermsOutcome,
            IncoTermsOutcome: DocOutcomeData.IncoTermsOutcome,
            LocalStockOutcome: DocOutcomeData.LocalStockOutcome,
            PaymentTermsTargetAchieved: DocOutcomeData.PaymentTermsTargetAchieved,
            IncoTermsTargetAchieved: DocOutcomeData.IncoTermsTargetAchieved,
            LocalStockTargetAchieved: DocOutcomeData.LocalStockTargetAchieved,
            AchievedTarget: DocOutcomeData.AchievedTarget,
            TotalNegotiationRounds: TargetValueData.negotiationRounds,
            EndedWithArgument: DocOutcomeData.agreement,
            OverallSuccessRate: formik.values.Rating,
            OverallNegotiationComment: formik.values.improvements,
            NextNegotiationSupplierNotes: formik.values.supplier,
            NextNegotiationSalesrepNotes: formik.values.leadSalesRep,
            LeadSalesrepReminder: formik.values.nextNegotiation,
            ConfirmPreviousStrategyType: SalesRepData?.salesRepClassificationTitle,
            SelectedStrategyType: salesRepType.id,
            NegotiationRoundsDetails: outputData,
            Status: "Completed"
        }
        dispatch({
            type: SAVE_DOCUMENT_OUTCOME, payload: finalData,
            meta: {
                onSuccess: () => {
                    navigate("/");
                }
            }
        })
        setSaveReview(false);
    }

    const handleDropdownChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedTitle = e.target.value;
        const selected = salesRepClassficationList?.find((opt: any) => opt.title === selectedTitle);
        if (selected) {
            setSalesRepType({ id: selected.id, title: selected.title });
        }
    };
    const [allCardsRated, setAllCardsRated] = useState(false);

    useEffect(() => {
        setAllCardsRated(areAllCardsRated());
        if (salesRepType.title == null || salesRepType.title == undefined || salesRepType.title == "") {
            setIsSalesRepNull(true);
        }
        else { setIsSalesRepNull(false) }
    }, [cardDataByRound, negotiationCards, salesRepType]);

    return (
        <div className="ReviewNegotiation">
            <form onSubmit={formik.handleSubmit}>
                <div><b>Initial negotiation targets vs outcome:</b></div>
                <div>
                    <Table responsive>
                        <thead className="bg-light">
                            <tr>
                                <th> </th>
                                <th>Initial target</th>
                                <th>Outcome</th>
                                <th>Target achievement</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* Row 1: Price change */}
                            <tr >
                                <td className="grey-row"><b>Price change</b></td>
                                <td className="grey-row">{TargetValueData?.negotiationTarget}%</td>
                                <td className="grey-row">{DocOutcomeData?.TargetOutcome}%</td>
                                <td className="grey-row" >{DocOutcomeData?.AchievedTarget}%</td>
                            </tr>
                            {/* Row 2: Discount terms */}
                            <tr>
                                <td className="grey-row2 column1" ><b>Discount terms</b></td>
                                <td className="grey-row2 column2"></td>
                                <td className="grey-row2 column3">{DocOutcomeData?.DiscountTerms}</td>
                                <td className="grey-row2 column4">
                                </td>
                            </tr>
                            {/* Row 3: Payment terms */}
                            {TargetValueData?.paymentTerms !== "" && (<tr>
                                <td className="grey-row"><b>Payment terms</b></td>
                                <td className="grey-row">{TargetValueData?.paymentTerms}</td>
                                <td className="grey-row">{DocOutcomeData?.PaymentTermsOutcome}</td>
                                <td className="grey-row">{DocOutcomeData?.PaymentTermsTargetAchieved} </td>
                            </tr>)}
                            {/* Row 4: Inco terms */}
                            {TargetValueData?.incoTerms !== "" && (<tr>
                                <td className="grey-row2"><b>Inco terms</b></td>
                                <td className="grey-row2">{TargetValueData?.incoTerms}</td>
                                <td className="grey-row2">{DocOutcomeData?.IncoTermsOutcome}</td>
                                <td className="grey-row2">{DocOutcomeData?.IncoTermsTargetAchieved}</td>
                            </tr>
                            )}
                            {/* Row 5: Local stock */}
                            {TargetValueData?.localStock !== "" && (<tr>
                                <td className="grey-row"><b>Local stock</b></td>
                                <td className="grey-row">{TargetValueData?.localStock}</td>
                                <td className="grey-row">{DocOutcomeData?.LocalStockOutcome}</td>
                                <td className="grey-row">{DocOutcomeData?.LocalStockTargetAchieved}</td>
                            </tr>)}
                        </tbody>
                    </Table>
                </div>
                <div><b>Please review the overall negotiation by answering to the following questions:</b></div>
                <div className="Review-rows">
                    <div className="first-column">
                        <div className="text-column">
                            <div className="text-label">
                                How would you rate the <b>overall success</b> of the negotiation? <span style={{color:"red"}}>*(required)</span> 
                            </div>
                        </div>

                    </div>
                    <div className="second-column">
                        <div >
                            {[...Array(maxRating)].map((_, i) => {
                                const starVal = i + 1;
                                return (
                                    <button
                                        key={starVal}
                                        type="button"
                                        onClick={() => formik.setFieldValue("Rating", starVal)}
                                        onMouseEnter={() => setHover(starVal)}
                                        onMouseLeave={() => setHover(0)}
                                        className="review_negotiation_stars"
                                        style={{ color: starVal <= (hover || formik.values.Rating) ? "#004e8c" : "#ccc" }}
                                    >
                                        ★
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                </div>
                <div className="Review-rows">
                    <div className="first-column">
                        <div className="text-column">
                            <div className="text-label">
                                Looking back at the negotiation: What should have been <b>done differently/better</b>
                                 <span style={{color:"red"}}>{' '}*(required)</span> 
                            </div>
                        </div>
                    </div>
                    <div className="second-column">
                        <Input
                            type="textarea"
                            rows={4}
                            name="improvements"
                            value={formik.values.improvements}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            style={{ fontSize: '14px' }}
                        />
                        <div>
                            {" "}
                            {formik.errors.improvements && (
                                formik.touched.improvements && (
                                    <div
                                        className="error-text"
                                        style={{ justifyContent: "space-around" }}
                                    >
                                        {formik.errors.improvements}
                                    </div>)
                            )}
                        </div>
                    </div>
                </div>
                <div className="Review-rows">
                    <div className="first-column">
                        <div className="text-column">
                            <div className="text-label">
                                Which <b>information</b> should <b>be taken into account</b> during the next negotiation?
                                 <span style={{color:"red"}}>{' '}*(required)</span> 
                            </div>
                        </div>
                    </div>
                    <div className="Inputs">
                        <div >...regarding the <b>supplier</b>?</div>
                        <Input
                            type="textarea"
                            rows={4}
                            name='supplier'
                            value={formik.values.supplier}
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            style={{ fontSize: '14px' }}
                        />
                        <div>
                            {" "}
                            {formik.errors.supplier && (
                                formik.touched.supplier && (
                                    <div
                                        className="error-text"
                                        style={{ justifyContent: "space-around" }}
                                    >
                                        {formik.errors.supplier}
                                    </div>
                                )
                            )}
                        </div>
                        <div >...regarding the <b>lead sales rep?</b></div>
                        <Input
                            type="textarea"
                            rows={4}
                            name="leadSalesRep"
                            value={formik.values.leadSalesRep}
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            style={{ fontSize: '14px' }}
                        />
                        <div>
                            {" "}
                            {formik.errors.leadSalesRep && (
                                formik.touched.leadSalesRep && (
                                    <div
                                        className="error-text"
                                        style={{ justifyContent: "space-around" }}
                                    >
                                        {formik.errors.leadSalesRep}
                                    </div>)
                            )}
                        </div>
                    </div>
                </div>
                <div className="Review-rows">
                    <div className="first-column">
                        <div className="text-column">
                            <div className="text-label">
                                What should the lead sales rep be <b>reminded of at the next negotiation</b>?
                                <br />(E.g. concessions that were made; facts that were agreed upon; visions that were jointly developed, etc.)
                            </div>
                        </div>
                    </div>
                    <div className="second-column">
                        <Input
                            type="textarea"
                            rows={4}
                            name='nextNegotiation'
                            value={formik.values.nextNegotiation}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            style={{ fontSize: '14px' }}
                        />
                        <div>
                            {" "}
                            {formik.errors.nextNegotiation && (
                                formik.touched.nextNegotiation && (
                                    <div
                                        className="error-text"
                                        style={{ justifyContent: "space-around" }}
                                    >
                                        {formik.errors.nextNegotiation}
                                    </div>
                                )
                            )}
                        </div>
                    </div>
                </div>
                {negotiationCards
                    ?.some(
                        (round: any) =>
                            round.roundName === 'Preparation' &&
                            round.selectedAction?.some((action: any) => action.isNegotiationActionUsed)
                    ) && (
                        <div>
                            <div style={{ marginTop: '2rem' }}><b> Please rate the <u>preparation actions</u> you used according to how successful they were 
                            <span style={{color:"red"}}>{' '}*(required)</span></b></div>
                            <div><div className="card-rating">
                                <div>
                                    <div className='review-cards-grid'>
                                        {negotiationCards
                                            ?.filter((round: any) => round.roundName === 'Preparation')
                                            .flatMap((round: any) =>
                                                round.selectedAction?.filter((action: any) => action.isNegotiationActionUsed).map((action: any) => (
                                                    <div key={action.id}>
                                                        <NewCard
                                                            id={action.id}
                                                            title={action.negotiationActionTitle}
                                                            description={action.negotiationActionDescription}
                                                            roundName="Preparation"
                                                            ActionEffectivenessReason={cardDataByRound[round.roundName]?.find(item => item.cardId === action.id)?.ActionEffectivenessReason || ""}
                                                            onCardDataChange={handleCardDataChange}
                                                        />
                                                    </div>
                                                ))
                                            )}
                                    </div>
                                </div>
                            </div></div>
                        </div>
                    )}
                {negotiationCards
                    ?.some(
                        (round: any) =>
                            /^Round([1-9]|10)$/.test(round.roundName) &&
                            round.selectedAction?.some((action: any) => action.isNegotiationActionUsed)
                    ) && (
                        <div style={{ marginTop: '2rem' }}><div><b> Please rate the <u>Negotiation actions</u> you used according to how successful they were <span style={{color:"red"}}>{' '}*(required)</span></b></div>
                            <div><div className="card-rating">
                                <div>
                                    <div className='review-cards-grid'>
                                        {Array.from(
                                            new Map(
                                                negotiationCards
                                                    ?.filter((round: any) => /^Round([1-9]|10)$/.test(round.roundName))
                                                    .flatMap((round: any) =>
                                                        round.selectedAction?.filter((action: any) => action.isNegotiationActionUsed).map((action: any) => ({
                                                            ...action,
                                                            roundName: "NegotiationRound",
                                                        })) || []
                                                    )
                                                    .filter((action: any) => action.isNegotiationActionUsed) //only show used actions
                                                    .map((action: any) => [action.id, action]) // create [id, action] pair
                                            ).values() // deduplicated by id using Map
                                        ).map((action: any) => (
                                            <div key={action.id}>
                                                <NewCard
                                                    id={action.id}
                                                    title={action.negotiationActionTitle}
                                                    description={action.negotiationActionDescription}
                                                    roundName="NegotiationRound"
                                                    ActionEffectivenessReason={
                                                        cardDataByRound["NegotiationRound"]?.find(item => item.cardId === action.id)?.ActionEffectivenessReason || ""
                                                    }
                                                    
                                                    onCardDataChange={handleCardDataChange}
                                                />
                                            </div>
                                        ))}


                                    </div>
                                </div>
                            </div></div>
                        </div>)}
                {negotiationCards
                    ?.some(
                        (round: any) =>
                            round.roundName === 'Finalization' &&
                            round.selectedAction?.some((action: any) => action.isNegotiationActionUsed)
                    ) && (
                        <div style={{ marginTop: '2rem' }}>
                            <div><b> Please rate the <u>finalization actions</u> you used according to how successful they were <span style={{color:"red"}}>{' '}*(required)</span></b></div>
                            <div><div className="card-rating">
                                <div>
                                    <div className='review-cards-grid'>
                                        {negotiationCards
                                            ?.filter((round: any) => round.roundName === 'Finalization')
                                            .flatMap((round: any) =>
                                                round.selectedAction?.filter((action: any) => action.isNegotiationActionUsed).filter((action: any) => action.isNegotiationActionUsed).map((action: any) => (
                                                    <div key={action.id}>
                                                        <NewCard
                                                            id={action.id}
                                                            title={action.negotiationActionTitle}
                                                            description={action.negotiationActionDescription}
                                                            roundName="Finalization"
                                                            ActionEffectivenessReason={cardDataByRound[round.roundName]?.find(item => item.cardId === action.id)?.ActionEffectivenessReason || ""}
                                                            onCardDataChange={handleCardDataChange}
                                                        />
                                                    </div>
                                                ))
                                            )}
                                    </div>
                                </div>
                            </div></div>
                        </div>)}
                <div className="salesRepClassificationContainer1">

                    <div><b>Initially assigned sales rep negotiation strategy type -</b> {SalesRepData?.salesRepClassificationTitle == null ? <b style={{ color: 'red' }}> (Not selected)</b> : <b>{SalesRepData?.salesRepClassificationTitle}</b>}</div>
                    <div className="strategy-type">
                        <div style={{ width: '30%' }}>
                            <div className="select-strategy-type">
                                <div>Select sales rep negotiation strategy type</div>
                                <div style={{ marginBottom: '1.5rem' }}>
                                    <select value={salesRepType?.title} onChange={handleDropdownChange} className='select-dropdown'>
                                        <option value="">Select
                                        </option>
                                        {salesRepClassficationList.length > 0 && salesRepClassficationList?.map((type: any) => (
                                            <option key={type.id} value={type.title}>
                                                {SalesRepData?.salesRepClassificationTitle === type.title ? (type.title + " (Initially assigned)") : type.title}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            {salesRepType?.title == "Rationalist" &&
                                <div className="repCard">
                                    <SaleRepClassificationCard
                                        classList={"card1"}
                                        cardImg={RationalistImg}
                                        cardHeading="Rationalist"
                                        subHeading="“The truth of the story lies in the details”"
                                        cardContent={cardContentArr[0]}
                                        cardSelected={salesRepType.title}
                                        cardHandler={() => { }}
                                    />
                                </div>}
                            {salesRepType?.title == "Performer" &&
                                <div className="repCard">
                                    <SaleRepClassificationCard
                                        classList={"card2"}
                                        cardImg={PerformerImg}
                                        cardHeading="Performer"
                                        subHeading="“Don’t let anything stop you from reaching your goals”"
                                        cardContent={cardContentArr[1]}
                                        cardSelected={salesRepType.title}
                                        cardHandler={() => { }}
                                    />
                                </div>}
                            {salesRepType?.title == "Harmonizer" &&
                                <div className="repCard">
                                    <SaleRepClassificationCard
                                        classList={"card3"}
                                        cardImg={HarmonizerImg}
                                        cardHeading="Harmonizer"
                                        subHeading="“Keep calm to achieve your goals”"
                                        cardContent={cardContentArr[2]}
                                        cardSelected={salesRepType.title}
                                        cardHandler={() => { }}
                                    />
                                </div>}
                            {salesRepType?.title == "Optimizer" &&
                                <div className="repCard">
                                    <SaleRepClassificationCard
                                        classList={"card4"}
                                        cardImg={OptimizerImg}
                                        cardHeading="Optimizer"
                                        subHeading="“Minimal efforts to achieve given goals”"
                                        cardContent={cardContentArr[3]}
                                        cardSelected={salesRepType.title}
                                        cardHandler={() => { }}
                                    />
                                </div>
                            }
                        </div>



                    </div>

                </div>
                <div className="modal-popup">
                    <div className="submit-button-note">(Please fill all the required fields to enable submit button.)  </div>
                    <button className="continue-button" onClick={handleSubmitClick} disabled={!allCardsRated || isNextDisabled || isSalesRepNull}>Submit Review</button>
                    <Modal isOpen={saveReview} toggle={() => setSaveReview(false)}>
                        <ModalHeader toggle={() => setSaveReview(false)}>Submit Review</ModalHeader>
                        <ModalBody>
                            Do you really wish to submit the review ? You cannot return to the review page afterwards!
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" size="sm" onClick={() => setSaveReview(false)}>Back</Button>
                            <Button color="primary" size="sm" onClick={confirmSubmit}>Submit review</Button>
                        </ModalFooter>
                    </Modal>
                </div>
                <ToastNotifier></ToastNotifier>
            </form>
        </div>
    )
}
export default ReviewNegotiation;